import { render } from "./MotorParameterFileTable.vue?vue&type=template&id=28ea8245&scoped=true"
import script from "./MotorParameterFileTable.vue?vue&type=script&lang=js"
export * from "./MotorParameterFileTable.vue?vue&type=script&lang=js"

import "./MotorParameterFileTable.vue?vue&type=style&index=0&id=28ea8245&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ea8245"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/ParameterFileComponent/MotorParameterFileTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28ea8245"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28ea8245', __exports__)) {
    api.reload('28ea8245', __exports__)
  }
  
  module.hot.accept("./MotorParameterFileTable.vue?vue&type=template&id=28ea8245&scoped=true", () => {
    api.rerender('28ea8245', render)
  })

}


export default __exports__